//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            prospect: {},
            check_role: false
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            window.axios.post('/prototype/prospect/' + this.prospect.id, this.prospect).then(function (response) {
                Event.$emit('get-prospects');
                Event.$emit('guest-card-dashboard-updated');
                _this.$children[0].$data.showModal = false;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        Event.$on('edit-prospect', function (prospect) {
            _this2.prospect = prospect;
            _this2.$children[0].$data.showModal = true;
            _this2.check_role = window.user.role === 'super-admin';
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/prospects/ProspectEdit.vue
// module id = JIpw
// module chunks = 0 1